import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function DeveloperRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user || user.role !== "developer") return <Navigate to="/backoffice/login" replace />;

  return children;
}
